export default __webpack_public_path__ + "static/media/LeftButton.3c41f089.svg";